import axios from 'axios';
export const performLocationSearch = async (config, query) => {
    try {
        const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${config.MAPBOX_API_KEY}&types=locality,neighborhood,place,poi`;
        const res = await axios.get(url);
        return res.data.features.map((result) => {
            return {
                name: result.place_name,
                shortName: result.text,
                latitude: result.geometry.coordinates[1],
                longitude: result.geometry.coordinates[0]
            };
        });
    }
    catch (error) {
        console.log('AWS error (getEndpoint)', error);
        return undefined;
    }
};
export const reverseGeocode = async (config, latitude, longitude) => {
    try {
        const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${config.MAPBOX_API_KEY}&types=locality,neighborhood,place`;
        const res = await axios.get(url);
        console.log('performLocationSearch', { res });
        return res.data.features.map((result) => {
            return {
                name: result.place_name,
                shortName: result.text,
                latitude: result.geometry.coordinates[1],
                longitude: result.geometry.coordinates[0]
            };
        });
    }
    catch (error) {
        console.log('AWS error (getEndpoint)', error);
        return undefined;
    }
};
//# sourceMappingURL=mapbox.js.map